/* eslint-disable */
import React, {useState} from 'react';
//component
import Paging from '../../component/Inc/Paging';
import PopRequestPoint from '../mypage/_PopRequestPoint';
import PopPolicyPoint from '../mypage/_PopPolicyPoint';
//css
import 'contents/assets/scss/page/teacher.scss';
function ManagePointDetail() {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalPolicyOpen, setModalPolicyOpen] = useState(false);
  return (
    <main className="com_container com_point_detail">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className='com_pg_tit icon menu2_7'>포인트 내역 <span className="bar"/><span className="point_txt">상세보기 (최교사103ㆍ교무부ㆍ교사관리팀)</span></h2>
          <div className="com_btn_wrap">
            <button onClick={() => setModalPolicyOpen(true)} className="com_btn orange s btn_plus">포인트 정책</button>
            <button onClick={() => setModalOpen(true)} className="com_btn orange s btn_plus">포인트 요청</button>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className='com_board_list__top'>
              <p className="com_pg_tit">2025.08.25 입사</p>
              <button className="com_btn black s">진급 대상자</button>
            </div>
            <table className='com_board_list'>
              <colgroup>
                <col width="5%"/><col width="8%"/>
                <col width="8%"/><col width="9%"/>
                <col width="15%"/><col width="7%"/>
                <col width="7%"/><col width="7%"/>
                <col width="7%"/><col width="7%"/>
                <col width="7%"/><col width="12%"/>
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th><th>요청일</th>
                  <th>요청자</th><th>요청항목</th>
                  <th>요청내용</th><th>요청포인트</th>
                  <th>총 지급P</th><th>보유P</th>
                  <th>진급P</th><th>진급가점</th>
                  <th>필요가점</th><th>상태</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>20</td>
                  <td className='td_date'>2022.08.25</td>
                  <td>김길동111</td>
                  <td>교재제작검토</td>
                  <td>8월 초타오류 검수</td>
                  <td className='td_point'>+53</td>
                  <td>23</td>
                  <td>23</td>
                  <td>23</td>
                  <td>23</td>
                  <td>-</td>
                  <td className='td_red'>승인불가<br />2025.8.30</td>
                </tr>
                {[1,2,3,4,5,6,7,8,9,10].map((i,idx) => {
                  return (
                    <tr key={idx}>
                      <td>{10 - idx}</td>
                      <td className='td_date'>2022.08.25</td>
                      <td>김길동111</td>
                      <td>교재제작검토</td>
                      <td>8월 초타오류 검수</td>
                      <td className='td_red'>-20</td>
                      <td>23</td>
                      <td>23</td>
                      <td>23</td>
                      <td>23</td>
                      <td>-</td>
                      <td className='td_point'>승인<br />2025.8.30</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
            <Paging />
          </section>
          <section className="box">
            <div className="detail_tit dot">포인트 사용 내역</div>
            <table className='com_board_list'>
              <tbody>
                <tr>
                  <th>총 포인트</th>
                  <td className='td_point'>6,234,434</td>
                  <th>현 보유 포인트</th>
                  <td className='td_point'>122,233</td>
                </tr>
              </tbody>
            </table>
            <table className='com_board_list'>
              <colgroup>
                <col width="5%"/><col width="10%"/>
                <col width="9%"/><col width="9%"/>
                <col width="9%"/><col width="10%"/>
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>변경일</th>
                  <th>요청자</th>
                  <th>요청내용</th>
                  <th>등록</th>
                  <th>보유포인트</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>20</td>
                  <td className='td_date'>2022.08.25</td>
                  <td>김길동111</td>
                  <td>교재제작검토</td>
                  <td className='td_red'>-20</td>
                  <td>600</td>
                </tr>
                {[1,2,3,4,5,6,7,8,9,10].map((i,idx) => {
                  return (
                    <tr key={idx}>
                      <td>{10 - idx}</td>
                      <td className='td_date'>2022.08.25</td>
                      <td>김길동111</td>
                      <td>교재제작검토</td>
                      <td className='td_point'>+53</td>
                      <td>600</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
            <div className="com_board_box">
              <div className="board_item">
                <button className="name">홍길동103 </button><span className="desc dot">2022, 08, 25  19:30</span>
                <button className="btn_edit" />
                <hr className='com_divider'/>
                <div className='info'>
                  <p className='tit'><span className="dot" />요청사유</p>
                  <p className="cont">교관활동 <span className="bar" /> 정기교육</p>
                </div>
                <div className='info'>
                  <p className='tit'><span className="dot" />요청 포인트</p>
                  <p className='cont com_blue_txt'>+23</p>
                </div>
                <div className='info'>
                  <p className='tit'><span className="dot" />메모</p>
                  <p className="cont">2023년 3기 교관활동을 16회 하였습니다.</p>
                </div>
              </div>
              <div className="board_item">
                <button className="name">홍길동103 </button><span className="desc dot">2022, 08, 25  19:30</span>
                <button className="com_btn gray btn_change">포인트 변경</button>
                <button className="btn_edit" />
                <hr className='com_divider'/>
                <div className='info'>
                  <p className='tit'><span className="dot" />요청사유</p>
                  <p className="cont">교관활동 <span className="bar" /> 정기교육</p>
                </div>
                <div className='info'>
                  <p className='tit'><span className="dot" />요청 포인트</p>
                  <p className='cont com_blue_txt'>+23</p>
                </div>
                <div className='info'>
                  <p className='tit'><span className="dot" />메모</p>
                  <p className="cont">2023년 3기 교관활동을 16회 하였습니다.</p>
                </div>
              </div>
              <div className="confirm">
                <select className="select">
                  <option value="승인">승인</option>
                  <option value="포인트 변경">포인트 변경</option>
                  <option value="승인 불가">승인 불가</option>
                </select>
                <div className="info_box">
                  <div className='info'>
                    <p className='tit dot'>요청사유</p>
                    <p className='cont'>교관활동 <span className="bar" /> 정기교육</p>
                  </div>
                  <div className='info'>
                    <p className='tit dot'>요청 포인트</p>
                    <p className='cont com_blue_txt'>+23</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="re_box">
              <textarea className="textarea" placeholder='내용 입력'></textarea>
            </div>
            <div className="com_btn_wrap center">
              <button className="com_btn orange xs">승인</button>
            </div>
          </section>
        </section>
      </div>
      <PopRequestPoint open={modalOpen} close={() => setModalOpen(false)} />
      <PopPolicyPoint open={modalPolicyOpen} close={() => setModalPolicyOpen(false)} />
    </main>
  );
}

export default ManagePointDetail;
